<template>
  <div class="tw-flex tw-flex-col tw-flex-grow tw-overflow-hidden">
    <!-- Student camera placeholder (top 50%) -->
    <div v-if="view.showStudentVideo" class="tw-flex-shrink-0 tw-h-[50vh] tw-bg-exam-dark" />
    <PreparationProgressBar v-if="isPreparationStep" />
    <div v-if="view.image" class="tw-flex-grow tw-flex tw-items-center tw-justify-center tw-px-6 tw-min-h-0">
      <img
        :src="originUrl + view.image"
        class="tw-max-w-full tw-max-h-full tw-object-contain"
        alt=""
      />
    </div>
    <div v-else-if="view.content" class="tw-flex tw-flex-grow tw-items-center tw-justify-center tw-flex-col tw-px-6">
      <h1 class="tw-text-xl tw-font-bold tw-mb-6 tw-text-center tw-text-white">
        {{ view.content }}
      </h1>
    </div>
  </div>
</template>

<script>
import PreparationProgressBar from './PreparationProgressBar.vue';

export default {
  name: 'ExamIntro',
  components: {
    PreparationProgressBar,
  },
  props: {
    view: Object,
  },
  data() {
    return {
      hasEmittedTakeStudentPhoto: false,
      hasResetTakeStudentPhoto: false,
    };
  },
  computed: {
    isPreparationStep() {
      const { module: idx } = this.$store.state.exam.current;
      const mod = this.$store.state.exam.modules[idx];
      if (!mod) return false;
      return (mod.key && mod.key.endsWith('INSTR')) || mod.key === '0IN';
    },
    originUrl() {
      return this.$store.state.originUrl;
    },
  },
  methods: {
    handleRenderExaminerCamera(isViewVideo) {
      const mode = isViewVideo ? 'partial' : 'none';
      // eslint-disable-next-line no-console
      console.log(`[CAMERA] Examiner camera (intro): ${mode} (key=${this.$store.state.exam.modules[this.$store.state.exam.current.module]?.key})`);
      this.$socket.emit('renderExaminerCamera', mode);
    },
    handleRenderStudentCamera(isViewVideo) {
      const mode = isViewVideo ? 'partial' : 'none';
      // eslint-disable-next-line no-console
      console.log(`[CAMERA] Student camera: ${mode} (key=${this.$store.state.exam.modules[this.$store.state.exam.current.module]?.key})`);
      this.$socket.emit('renderStudentCamera', mode);
    },
    handleShouldTakeStudentPhoto(shouldTakeStudentPhoto) {
      if (shouldTakeStudentPhoto) {
        this.$socket.emit('shouldTakeStudentPhoto', true);
        this.hasEmittedTakeStudentPhoto = true;
        this.hasResetTakeStudentPhoto = false;
        return;
      }

      if (!this.hasEmittedTakeStudentPhoto || this.hasResetTakeStudentPhoto) return;

      this.$socket.emit('shouldTakeStudentPhoto', false);
      this.hasResetTakeStudentPhoto = true;
    },
  },
  mounted() {
    this.handleRenderExaminerCamera(this.view.video);
    this.handleRenderStudentCamera(this.view.showStudentVideo);
    this.handleShouldTakeStudentPhoto(this.view.shouldTakeStudentPhoto);
  },
  watch: {
    view: {
      handler() {
        this.handleRenderExaminerCamera(this.view.video);
        this.handleRenderStudentCamera(this.view.showStudentVideo);
        this.handleShouldTakeStudentPhoto(this.view.shouldTakeStudentPhoto);
      },
      deep: true,
    },
  },
};
</script>
